import { toast } from 'react-toastify';

const notify = {
  success: (msg) => toast.success(msg),
  info: (msg) => toast.info(msg),
  error: (msg) => toast.error(msg),
};
const warn = (msg) => toast.warn(msg);

export { notify, warn };
